import { Datepicker } from 'vanillajs-datepicker';
import it from './it';

export default function bookInitCalendar(elCalendar: string) { 

    const elem = document.querySelector(elCalendar) as HTMLInputElement;

    if(elem === null){

        return null;

    }

    Object.assign(Datepicker.locales, it);

    const datepicker = new Datepicker(elem, {
        language : 'it',
        minDate: new Date(),
        autohide: true,
        // datesDisabled: ['2024-10-29'],
    }); 

    return datepicker;

}